import CompanyService from "./company.service";
import UserService from "./user.service";
import AnalyticsService from "./analytics.service";

export default {
  CompanyService,
  UserService,
  AnalyticsService,
};
